import { useState } from "react";
import OverflowMenu from "./OverflowMenu";

## Basic Usage

<OverflowMenu
  menuItems={[
    { children: "Edit", onClick: () => alert("Edit clicked") },
    { children: "Duplicate", onClick: () => alert("Duplicate clicked") },
    { children: "Delete", onClick: () => alert("Delete clicked") },
  ]}
/>

---

## Positions

<div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Bottom:</p>
    <OverflowMenu
      side="bottom"
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Top:</p>
    <OverflowMenu
      side="top"
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Right:</p>
    <OverflowMenu
      side="right"
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Left:</p>
    <OverflowMenu
      side="left"
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
</div>

---

## Alignment

<div style={{ display: "flex", gap: "2rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Start:</p>
    <OverflowMenu
      align="start"
      menuItems={[
        { children: "Aligned start" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Center:</p>
    <OverflowMenu
      align="center"
      menuItems={[
        { children: "Aligned center" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>End:</p>
    <OverflowMenu
      align="end"
      menuItems={[
        { children: "Aligned end" },
        { children: "Option 2" },
      ]}
    />
  </div>
</div>

---

## With Title and Close

<OverflowMenu
  title="Actions"
  showCloseIcon
  menuItems={[
    { children: "View details" },
    { children: "Edit" },
    { children: "Share" },
    { children: "Delete" },
  ]}
/>

---

## Disabled State

<div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Enabled:</p>
    <OverflowMenu
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>Disabled:</p>
    <OverflowMenu
      disabled
      menuItems={[
        { children: "Option 1" },
        { children: "Option 2" },
      ]}
    />
  </div>
</div>

---

## Controlled State

export function ControlledMenu() {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <OverflowMenu
        open={open}
        onOpenChange={setOpen}
        menuItems={[
          { children: "Option 1", onClick: () => setOpen(false) },
          { children: "Option 2", onClick: () => setOpen(false) },
        ]}
      />
      <span>Menu is {open ? "open" : "closed"}</span>
    </div>
  );
}

<ControlledMenu />

---

## With Custom Children Content

<OverflowMenu title="Settings">
  <div style={{ padding: "0.5rem" }}>
    <p style={{ marginBottom: "0.5rem", fontWeight: 500 }}>Custom content</p>
    <p style={{ fontSize: "14px", color: "#666" }}>
      You can render any content here instead of using menuItems.
    </p>
  </div>
</OverflowMenu>

---

## In a Table Row Context

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.75rem 1rem", borderBottom: "1px solid #e5e5e5" }}>
    <span>Document 1.pdf</span>
    <OverflowMenu
      side="bottom"
      align="end"
      menuItems={[
        { children: "Download" },
        { children: "Share" },
        { children: "Rename" },
        { children: "Delete" },
      ]}
    />
  </div>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.75rem 1rem", borderBottom: "1px solid #e5e5e5" }}>
    <span>Spreadsheet.xlsx</span>
    <OverflowMenu
      side="bottom"
      align="end"
      menuItems={[
        { children: "Download" },
        { children: "Share" },
        { children: "Rename" },
        { children: "Delete" },
      ]}
    />
  </div>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.75rem 1rem" }}>
    <span>Image.png</span>
    <OverflowMenu
      side="bottom"
      align="end"
      menuItems={[
        { children: "Download" },
        { children: "Share" },
        { children: "Rename" },
        { children: "Delete" },
      ]}
    />
  </div>
</div>


